// extracted by mini-css-extract-plugin
export var animationContainer = "_hx-0";
export var asteriskIcon = "_hx-8";
export var conversationLeftSection = "_hx-4";
export var conversationListItem = "_hx-3";
export var conversationMiddleSection = "_hx-5";
export var conversationRightSection = "_hx-6";
export var detailsContent = "_hx-1";
export var listContainer = "_hx-7";
export var modalContent = "_hx-2";